import { render, staticRenderFns } from "./DashboardCloth.vue?vue&type=template&id=3b416810&scoped=true&lang=html&"
import script from "./DashboardCloth.vue?vue&type=script&lang=js&"
export * from "./DashboardCloth.vue?vue&type=script&lang=js&"
import style0 from "./DashboardCloth.vue?vue&type=style&index=0&id=3b416810&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b416810",
  null
  
)

export default component.exports